export const descriptionGroupQueryKeys = {
  all: ["descriptionGroups"] as const,
  list: (clientId: string, tenantId?: string | null) =>
    ["descriptionGroups", clientId, tenantId] as const,
  descriptions: (clientId: string, groupName: string, tenantId?: string | null) =>
    ["descriptions", clientId, groupName, tenantId] as const,
};
